export const VALUE_BALANCE = {
  USDT: 0,
  Toman: 1,
};

export const VALUE_INVESTMENT_FUND = {
  All: 0,
  Floating: 1,
  Fixed: 2,
};
